import { LoadingScriptStateInterface } from 'store/reducers/loadingScript/types';

export const initialLoadingScriptStoreState: LoadingScriptStateInterface = {
  SQLScript: '',
  sourceTables: [],
  pagesScript: [],
  activePageScript: '',
};
